const googleMapConfig = {
	apiKey: 'AIzaSyBVKXTuUmnd2bWzg5ASXjY8DQIyCytL5CA',
	apiKeyAutocomplete: 'AIzaSyA48PyZlY3gIWvHI9NYzUfa7G8-5Erj49w'
};

export default googleMapConfig;
